import React, { Component } from 'react';
import { Spinner } from '@mgc/react-components';

class Loading extends Component {
    render() {
        return (
            <div id="loadingPage">
                <Spinner />
            </div>
        );
    }
}

export default Loading;



// WEBPACK FOOTER //
// ./app/views/Loading.jsx